import React, { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

const MotionText = motion.create(Text);

export default function RotatingWord({ words, intervalMs = 3000 }) {
	const [index, setIndex] = useState(0);

	useEffect(() => {
		const timer = window.setInterval(() => {
			setIndex((i) => (i + 1) % words.length);
		}, intervalMs);
		return () => window.clearInterval(timer);
	}, [words.length, intervalMs]);

	return (
		<Text
			as='span'
			display='inline-block'
			position='relative'
			verticalAlign='bottom'
			minW={{ base: '9ch', md: '10ch' }}
			textAlign='left'>
			<AnimatePresence mode='wait'>
				<MotionText
					key={words[index]}
					as='span'
					display='inline-block'
					bgGradient='linear(to-r, cyan.300, blue.300)'
					bgClip='text'
					initial={{ opacity: 0, y: 14 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -14 }}
					transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}>
					{words[index]}
				</MotionText>
			</AnimatePresence>
		</Text>
	);
}
